import wAxios from '@/plugins/w/axios/models/axios'
import type { TokenHandshakeHandler } from './types'

export const getCitiesHandler: TokenHandshakeHandler = async params => {
	const search = String(params?.search || '').trim()

	const data = await wAxios.post_auth_data('v2/cities', { search })

	return {
		result: {
			data
		}
	}
}
